import { CardSubtitle } from '../../../../components/common';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { Tab } from '../../../../components/Card/CardTabs/CardTabs.styled';
import {
  ONLINE_AND_STAFF_AVAILABLE,
  StaffOnlyStatus,
} from './useAppointmentOnlineStaffOnlySplit';
import { OnlineOfflineType } from './useSelectAppointmentToBook';
import { TimePlanningTooltipWrapper } from '../../../../components/common/Tooltips/TimePlanningTooltipWrapper';

export const BookAppointmentOnlineStaffOnlySwitchSection = ({
  selectedAppointmentType,
  setSelectedAppointmentType,
  onlineSplitStatus,
}: {
  setSelectedAppointmentType: (type: OnlineOfflineType) => void;
  selectedAppointmentType: OnlineOfflineType;
  onlineSplitStatus: StaffOnlyStatus;
}) => {
  const { t } = useCommonTranslation();
  return (
    <>
      {onlineSplitStatus === ONLINE_AND_STAFF_AVAILABLE && (
        <>
          <CardSubtitle
            style={{
              display: 'flex',
              gap: 'var(--s1)',
            }}
          >
            {t('book_appt_choose_appt_type_header')}
          </CardSubtitle>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 'var(--s3)',
              marginBottom: 'var(--s3)',
            }}
          >
            <Tab
              variant="secondary"
              size="standard"
              $active={selectedAppointmentType === 'STAFF_ONLY'}
              onClick={() => setSelectedAppointmentType('STAFF_ONLY')}
            >
              {t('staff-only')}
            </Tab>
            <Tab
              variant="secondary"
              size="standard"
              $active={selectedAppointmentType === 'ONLINE'}
              onClick={() => setSelectedAppointmentType('ONLINE')}
            >
              {t('online')}
            </Tab>
            <TimePlanningTooltipWrapper
              style={{
                position: 'absolute',
                top: 'auto',
                right: 'var(--s3)',
              }}
              minWidth={300}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  fontSize: 'var(--body1)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'var(--s1)',
                  }}
                >
                  <div>{t('book_appt_choose_appt_type_online_explain')}</div>
                  <div>{t('book_appt_choose_appt_type_offline_explain')}</div>
                </div>
              </div>
            </TimePlanningTooltipWrapper>
          </div>
        </>
      )}
    </>
  );
};
